// src/components/IssueItemSingle.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { tokens } from "../../theme";
import { useSelector } from 'react-redux';
import { useTheme } from "@mui/material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // Import Close icon
import axios from 'axios';
import env from "react-dotenv";

const IssueItemSingle = ({ open, handleClose, fetchProducts }) => {
  const [products, setProducts] = useState([]);
  const [productId, setProductId] = useState('');
  const [quantity, setQuantity] = useState('');
  const [grnDetails, setGrnDetails] = useState([]); // Changed to an array
  const [selectedGRN, setSelectedGRN] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const submitLockRef = useRef(false);

  const [locationType, setLocationType] = useState('');
  const [planIds, setPlanIds] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [jobCardIds, setJobCardIds] = useState([]);
  const [selectedJobCardId, setSelectedJobCardId] = useState('');
  const [slipNos, setSlipNos] = useState([]);
  const [selectedSlipNo, setSelectedSlipNo] = useState('');
  const [comments, setComments] = useState(''); // New state for comments

  const user = useSelector((state) => state.user);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.key || location.key === 'default') {
      navigate("/");
    }
  }, [location, navigate]);

  useEffect(() => {
    fetchProductsList();
  }, []);

   const fetchPlanIds = async () => {
    // console.log('Backend URL:', process.env.REACT_APP_PJCBACKEND_URL);
     try {
       const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-job-card/planIds`);
      //  console.log('Fetched Plan IDs:', response.data); // Log the response
       setPlanIds(response.data);
     } catch (error) {
       console.error('Error fetching plan IDs:', error);
     }
   };

   const fetchJobCardIds = async (planId) => {
     try {
       const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-job-card/jc/${planId}`);
      //  console.log('Fetched Job Card IDs:', response.data); // Log the response
       setJobCardIds(response.data);
     } catch (error) {
       console.error('Error fetching job card IDs:', error);
     }
   };

     const fetchSlipNos = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_MISBACKEND_URL}/maintenanceSlipList/slips`);
        // console.log('Fetched Slip Numbers:', response.data); // Log the response
        setSlipNos(response.data);
    } catch (error) {
        console.error('Error fetching slip numbers:', error);
    }
};
  
useEffect(() => {
    if (productId) {
      fetchGRNDetails(productId); // Fetch GRN details directly using productId
    }
  }, [productId]);

  const fetchProductsList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const fetchGRNDetails = async (productId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/issue/grn-details-summary`, {
        params: { productId },     // No vendorId needed
      });
      setGrnDetails(response.data); // Set the GRN details list
    } catch (error) {
      console.error("Error fetching GRN details:", error);
      setGrnDetails([]); // Clear GRN details if there's an error
    }
  };

  const getOldestNonZeroGRN = () => {
    const validGRNs = grnDetails
      .filter(grn => grn.balance_quantity > 0) // Filter for positive balance quantities
      .sort((a, b) => new Date(a.grn_date) - new Date(b.grn_date)); // Sort by date
    return validGRNs.length > 0 ? validGRNs[0] : null; // Return the oldest one or null if none found
  };

  const handleUpdateQuantity = async (action) => {
    if (isSaving || submitLockRef.current) {
      return;
    }
    if (!productId || !quantity || quantity <= 0 || !selectedGRN) {
      alert('Please provide valid product, quantity and GRN details.');
      return;
    }

    // const selectedGRNDetails = grnDetails.find(grn => grn.grn_no === selectedGRN);
    // Find the selected GRN details based on grn_id
    const selectedGRNDetails = grnDetails.find(grn => grn.grn_id === selectedGRN);
    const oldestGRN = getOldestNonZeroGRN();

  if (!selectedGRNDetails) {
    alert('Invalid GRN selected.');
    return;
  }

  if (selectedGRNDetails.balance_quantity === 0) {
    alert('The selected GRN has no remaining balance.');
    return;
  }

  if (parseInt(quantity, 10) > selectedGRNDetails.balance_quantity) {
    alert('The entered quantity exceeds the remaining balance of the selected GRN.');
    return;
  }

  // Check if the selected GRN is the oldest one with a non-zero quantity
  // if (oldestGRN && selectedGRNDetails.grn_no !== oldestGRN.grn_no) {
  //   alert(`Please choose the oldest Quantity: ${oldestGRN.balance_quantity} | GRN No: ${oldestGRN.grn_no} | GRN Date: ${new Date(oldestGRN.grn_date).toLocaleDateString()}`);
  //   return;
  // }

  // Check if the selected GRN is the oldest one with a non-zero quantity
  if (oldestGRN && selectedGRNDetails.grn_id !== oldestGRN.grn_id) {
    alert(`Please choose the oldest Quantity: ${oldestGRN.balance_quantity} | GRN No: ${oldestGRN.grn_no} | GRN Date: ${new Date(oldestGRN.grn_date).toLocaleDateString()}`);
    return;
  }

    try {
      submitLockRef.current = true;
      setIsSaving(true);
      const userName = user?.userName;
      await axios.patch(
        `${process.env.REACT_APP_PJCBACKEND_URL}/api/products/update-quantity-issue`,
        {
          productId,
          quantity: parseInt(quantity, 10),
          action,
          userName,
          grnNo: selectedGRNDetails.grn_no,  // Keep this for reference
          grnDate: selectedGRNDetails.grn_date,
          location: locationType,
          plan_id: selectedPlanId,
          job_card_id: selectedJobCardId,
          slipNo: selectedSlipNo,
          comments, // Include comments in the request
          grn_id: selectedGRN // Pass the selected grn_id here
        }
      );
      fetchProducts(); // Refresh the product list
      handleCloseModal(); // Close the dialog
      navigate('/rawMaterialHome');
    } catch (error) {
      console.error('Error updating quantity:', error);
      alert('Failed to update quantity. Please try again.');
    } finally {
      submitLockRef.current = false;
      setIsSaving(false);
    }
  };

   // Function to reset form values
  const resetForm = () => {
    setProductId('');
    setQuantity('');
    setSelectedGRN('');
    setGrnDetails([]);
    setSelectedPlanId('');
    setSelectedJobCardId('');
    setSelectedSlipNo('');
    setLocationType('');
    setComments(''); // Reset comments
  };

  // Close modal and reset form without refreshing
  const handleCloseModal = () => {
    resetForm();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleCloseModal} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>
            Issue Item
          </Typography>
          <IconButton onClick={handleCloseModal} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            select
            label="Select Raw material"
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            fullWidth
          >
            <MenuItem value="">
              Select Raw material
            </MenuItem>
            {products
              .sort((a, b) => a.product_name.localeCompare(b.product_name)) // Sort products by product_name in ascending order
              .map((product) => (
              <MenuItem key={product.id} value={product.id}>
                {product.product_name}
              </MenuItem>
            ))}
          </TextField>
          {/* <TextField
            select
            label="Select GRN"
            value={selectedGRN || ''} // Use `selectedGRN` for controlled selection
            onChange={(e) => {
              setSelectedGRN(e.target.value); // Update the selected GRN
            }}
            fullWidth
            disabled={!productId}
          >
            <MenuItem value="">
              Select GRN
            </MenuItem>
            {grnDetails.length > 0 ? (
              grnDetails
                .filter(grn => grn.balance_quantity >= 0) // Filter out negative quantities
                .sort((a, b) => new Date(a.grn_date) - new Date(b.grn_date)) // Sort by date
                .map((grn, index, arr) => {
                  // Determine if the current GRN should be disabled
                  const isDisabled = index > 0 && arr[index - 1].balance_quantity === 0 && grn.balance_quantity === 0;
                  return (
                    <MenuItem
                      key={grn.grn_no}
                      value={grn.grn_no}
                      disabled={isDisabled}
                    >
                      {`Quantity: ${grn.balance_quantity} | GRN No: ${grn.grn_no} | GRN Date: ${new Date(grn.grn_date).toLocaleDateString()}`}
                    </MenuItem>
                  );
                })
            ) : (
              <MenuItem disabled>No GRN details found.</MenuItem>
            )}
          </TextField> */}

          <TextField
          select
          label="Select GRN"
          value={selectedGRN || ''}
          onChange={(e) => {
            setSelectedGRN(e.target.value);
          }}
          fullWidth
          disabled={!productId}
        >
          <MenuItem value="">
            Select GRN
          </MenuItem>
          {grnDetails.length > 0 ? (
            grnDetails
              .sort((a, b) => new Date(a.grn_date) - new Date(b.grn_date)) // Sort by date
              .map((grn, index, arr) => {
                // Disable if there's an older GRN with positive balance
                const hasOlderWithBalance = arr.some((g, i) => 
                  i < index && g.balance_quantity > 0
                );
                const isDisabled = hasOlderWithBalance || grn.balance_quantity === 0; // Disable if older with balance or current has 0 balance
                return (
                  <MenuItem
                    key={grn.grn_id}
                    value={grn.grn_id}
                    disabled={isDisabled}
                  >
                    {`Quantity: ${grn.balance_quantity} | GRN No: ${grn.grn_no} | GRN Date: ${new Date(grn.grn_date).toLocaleDateString()}`}
                  </MenuItem>
                );
              })
          ) : (
            <MenuItem disabled>No GRN details found.</MenuItem>
          )}
        </TextField>

        <TextField
            select
            label="Select Location Type"
            value={locationType}
            onChange={(e) => {
              setLocationType(e.target.value);
              if (e.target.value === 'Production') {
                fetchPlanIds();
              } else if (e.target.value === 'Maintenance') {
                fetchSlipNos();
              } else {
                // Reset states for other types
                setPlanIds([]);
                setJobCardIds([]);
                setSlipNos([]);
              }
            }}
            fullWidth
          >
            <MenuItem value="">
              Select Location Type
            </MenuItem>
            <MenuItem value="Production">Production</MenuItem>
            <MenuItem value="Maintenance">Maintenance</MenuItem>
            <MenuItem value="Packing">Packing</MenuItem>
            <MenuItem value="Quality">Quality</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>

          {locationType === 'Production' && (
            <>
              <TextField
                select
                label="Select Plan ID"
                value={selectedPlanId}
                onChange={(e) => {
                  setSelectedPlanId(e.target.value);
                  fetchJobCardIds(e.target.value); // Fetch job cards for the selected plan
                }}
                fullWidth
              >
                <MenuItem value="">
                  Select Plan ID
                </MenuItem>
                {planIds.map(plan => (
                  <MenuItem key={plan.plan_id} value={plan.plan_id}>
                   {plan.plan_id}
                  </MenuItem>
                ))}
              </TextField>

              {selectedPlanId && (
                <TextField
                  select
                  label="Select Job Card ID"
                  value={selectedJobCardId}
                  onChange={(e) => setSelectedJobCardId(e.target.value)}
                  fullWidth
                >
                  <MenuItem value="">
                    Select Job Card ID
                  </MenuItem>
                  {jobCardIds.map(job => (
                    <MenuItem key={job.job_card_id} value={job.job_card_id}>
                      {job.job_card_id}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </>
          )}

          {locationType === 'Maintenance' && (
            <TextField
              select
              label="Select Slip No"
              value={selectedSlipNo}
              onChange={(e) => setSelectedSlipNo(e.target.value)}
              fullWidth
            >
              <MenuItem value="">
                Select Slip No
              </MenuItem>
              {slipNos.map((slip, index) => (
                <MenuItem key={index} value={slip}>
                  {slip}
                </MenuItem>
              ))}
            </TextField>
          )}

          {/* <TextField
            label="Quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            fullWidth
            type="number"
          /> */}

          <TextField
            label="Quantity"
            value={quantity}
            onChange={(e) => {
              const enteredQuantity = e.target.value;
              const selectedGRNDetails = grnDetails.find(grn => grn.grn_id === selectedGRN);

              // Validate the entered quantity
              if (selectedGRNDetails && parseInt(enteredQuantity, 10) > selectedGRNDetails.balance_quantity) {
                alert('The entered quantity exceeds the remaining balance of the selected GRN. Please enter qty less than selected GRN qty.');
                setQuantity(''); // Optionally reset the quantity field
              } else {
                setQuantity(enteredQuantity);
              }
            }}
            fullWidth
            type="number"
          />

          {/* New Textarea for Comments */}
          <TextField
            label="Remark"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            fullWidth
            multiline
            rows={2} // Adjust the number of rows as needed
          />

        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={handleCloseModal} color="secondary" disabled={isSaving}
        sx={{ marginRight: 2,':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    }, }}
        >
          Cancel
        </Button>
        <Button onClick={() => handleUpdateQuantity('issue')} disabled={isSaving}
          sx={{backgroundColor:'#4863A0',':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    },}} 
                    variant="contained"
          >
          Issue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IssueItemSingle;
